<template>
  <v-tooltip bottom color="primary" open-delay="100">
    <template v-slot:activator="{ on }">
      <div
        class="back-button-container pt-3"
        v-on="on"
        @click="backToWorkspace()"
      >
        <BackToWorkspaceIcon class="back-button" />
      </div>
    </template>
    <span style="font-size: 9px">{{ $t("BackToWorkspaceSelection") }}</span>
  </v-tooltip>
</template>

<script>
import BackToWorkspaceIcon from "@/assets/home/choose.svg";
import { mapActions } from "vuex";

export default {
  name: "BackToWorkspaceSelection",

  components: {
    BackToWorkspaceIcon
  },

  methods: {
    ...mapActions(["setFullscreen"]),

    /**
     * Back to workspace selection
     * @returns {Promise<void>}
     */
    async backToWorkspace() {
      await this.setFullscreen(false);
      await this.$router.push({ name: "workspaces" });
    }
  }
};
</script>

<style scoped>
.back-button-container {
  height: 100%;
  margin: 0 5px;
  padding: 7px;
  cursor: pointer;
}

.back-button {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/NavBar/BackToWorkspaceSelection.vue